import type { FC } from 'react';

import { useField } from 'formik';
import { useCallback } from 'react';

import { NumberInput } from './NumberInput';

import type { NumberInputConnectedProps } from './NumberInput.interface';

export const NumberInputConnected: FC<NumberInputConnectedProps> = ({
  id,
  onChange,
  ...props
}) => {
  const [field, meta, { setValue }] = useField(props);

  const handleChange = useCallback(
    (newValue: number | undefined) => {
      setValue(newValue);

      if (onChange) {
        onChange(newValue);
      }
    },
    [setValue, onChange],
  );

  return (
    <NumberInput
      id={id || props.name}
      error={meta.touched && meta.error ? meta.error : undefined}
      {...props}
      {...field}
      onChange={handleChange}
    />
  );
};
